<div class="header">
    <h1>
        <img src="/assets/gyf.gif" width="128px" alt="logo" class="logo" />
    </h1>
    <h2>Simple GIF Tournament</h2>
    <input type="button" value="LEARN HOW TO PLAY" />
</div>

<style lang="scss">
    .header {
        margin-bottom: 2em;
        
        input[type="button"] {
            background-color: #131313;
            color: grey;
            border: none;
            padding: 1em;
            border-radius: 7px;
        }

        h1 {
            font-size: 6em;
            color: greenyellow;
            text-transform: uppercase;
            font-weight: 1000;

            margin: 0;
            margin-top: 5rem;
        }
        h2 {
            margin-top: 0;
            font-weight: normal;
            color: grey;
        }
    }
</style>
